import { client } from '@/client';
import { SystemRoles } from '@/client/users';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentUserState } from '@/store/features/users';
import Intercom from '@intercom/messenger-js-sdk';
import { useEffect } from 'react';

export const useIntercom = () => {
  const { user } = useAppSelector(selectCurrentUserState);

  useEffect(() => {
    const initializeIntercom = async () => {
      if (
        !user ||
        !process.env.REACT_APP_INTERCOM_FIN_APP_ID ||
        user.role?.code === SystemRoles.LEARNER
      ) {
        return;
      }

      try {
        const response = await client.default.getIntercomJwt();

        Intercom({
          app_id: process.env.REACT_APP_INTERCOM_FIN_APP_ID,
          intercom_user_jwt: response.jwt,
          session_duration: 86400000,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch Intercom JWT token:', error);
      }
    };

    initializeIntercom();
  }, [user]);
};
